import { Avatar, DropdownMenu, Stack, Text } from "@nudgebox/ui";
import { DarkThemeIcon, DownloadIcon, LightThemeIcon, LogOutIcon, SettingsIcon, SystemThemeIcon } from "@nudgebox/ui/icons";
import "@nudgebox/ui/tokens.stylex";
import { color, fontSize, media, radius, space } from "@nudgebox/ui/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { setInstallDialogOpen, useInstallState } from "@/lib/install.ts";
import { useOrgSlug } from "@/lib/params.ts";
import { sessionQuery } from "@/lib/queries.ts";
import { setThemePreference, type ThemePreference, useThemePreference } from "@/lib/theme.ts";
import { useSignOut } from "./useSignOut.ts";

/** Account menu. `compact` shows just the avatar, for the mobile top bar. */
export function UserMenu({
  compact = false
}: {
  compact?: boolean;
}) {
  const {
    data: session
  } = useSuspenseQuery(sessionQuery);
  const signOut = useSignOut();
  const theme = useThemePreference();
  const orgSlug = useOrgSlug();
  const install = useInstallState();
  if (!session) return null;
  return <DropdownMenu align={compact ? "end" : "start"} trigger={compact ? <button type="button" aria-label="Account" className="x78zum5 x6s0dn4 x1a62zme xc342km xjbqb8w x1b8pnsr x1enuzbz x1ypdohk x187nhsf xn3w4p2 x2lah0s xl56j7k xnjsko4 x257jf6">
            <Avatar name={session.user.name || session.user.email} src={session.user.image} size={28} />
          </button> : <button type="button" className="x78zum5 x6s0dn4 x1a62zme xh8yej3 xc9qbxq x8tjdam x1uu5im9 xc342km xoazux2 xjbqb8w x1b8pnsr x1enuzbz x1ypdohk">
            <Avatar name={session.user.name || session.user.email} src={session.user.image} size={24} />
            <span className="xket8oi x187ovcu xb3r6kr xlyipyv xuxw1ft">{session.user.email}</span>
          </button>} header={<Stack gap="none">
          <Text size="sm" weight="medium">
            {session.user.name}
          </Text>
          <Text size="xs" tone="tertiary">
            {session.user.email}
          </Text>
        </Stack>} items={[{
    type: "radio",
    label: "Theme",
    value: theme,
    onValueChange: (next: ThemePreference) => setThemePreference(next),
    options: [{
      value: "light",
      label: "Light",
      icon: <LightThemeIcon size={14} />
    }, {
      value: "dark",
      label: "Dark",
      icon: <DarkThemeIcon size={14} />
    }, {
      value: "system",
      label: "System",
      icon: <SystemThemeIcon size={14} />
    }]
  }, "separator", ...(install.available ? [{
    label: "Install app",
    icon: <DownloadIcon size={14} />,
    onSelect: () => setInstallDialogOpen(true)
  }] : []), {
    label: "Account settings",
    icon: <SettingsIcon size={14} />,
    render: <Link to="/$orgSlug/settings/account" params={{
      orgSlug
    }} />
  }, {
    label: "Sign out",
    icon: <LogOutIcon size={14} />,
    onSelect: () => void signOut()
  }]} />;
}